<div class="modal-header">
  <h4 class="modal-title"> {{ RequestPermissionName | translate }} &nbsp;
    <i *ngIf="RequestPermissionNotificationModel.RequestPermissionNotificationType ==
        requestPermissionNotificationType.DiscountPermission" class="fas fa-percent text-success"></i>
    <i *ngIf="RequestPermissionNotificationModel.RequestPermissionNotificationType ==
        requestPermissionNotificationType.SaleRefundPermission" class="fas fa-undo text-warning"></i>
    <i *ngIf="RequestPermissionNotificationModel.RequestPermissionNotificationType ==
        requestPermissionNotificationType.EditBillPermission" class="fas fa-edit text-info"></i>
    <i *ngIf="RequestPermissionNotificationModel.RequestPermissionNotificationType ==
        requestPermissionNotificationType.CancelBookingPermission" class="fas fa-times text-danger"></i>

  </h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div class="row">
    <div class="col-lg-12">
      <h5 style="padding: 30px;line-height: 35px;"> {{message}} </h5>
    </div>
  </div>
  <div class="row">

    <div class="form-group col-lg-12">
      <label>{{ 'SendFeedbackToAdmin-Optional' | translate }}</label>
      <input type="text" class="form-control" placeholder="{{ 'SendFeedbackToAdmin-Optional' | translate }}"
        [(ngModel)]="SendFeedbackToAdmin" name="SendFeedbackToAdmin" autocomplete="off" required maxlength="50">

    </div>
  </div>


</div>
<div class="modal-footer">
  <button type="button" class="btn btn-submit" *ngIf="!btnLoading" (click)="MakeRequestPermission()">
    {{ "RequestPermission" | translate }}
  </button>
  <button type="button" class="btn btn-submit" disabled *ngIf="btnLoading">
    <i class="fas fa-circle-notch fa-spin"></i> {{ 'Loading' | translate }}
  </button>
</div>
